export interface FaqItem {
  question: string
  answer: string
}

export const faqData: FaqItem[] = [
  {
    question: "Who is eligible for the 10% student discount?",
    answer:
      "The 10% student discount under the 'Indonesian Presenter with Publication' category applies to IPB University students.",
  },
  {
    question: "Are there any restrictions on the number of authors for each paper?",
    answer:
      "According to the IOP guidelines, there is no limit to the number of authors.",
  },
  {
    question: "Is it allowed to have more than one presenter for a paper?",
    answer: "Each paper may only be presented by one person.",
  },
  {
    question:
      "What is the policy for co-authors who wish to accompany the presenter at the conference?",
    answer:
      "Co-authors who would like to accompany the presenter and attend the conference may register as 'Participant Only' through the website.",
  },
  {
    question: "Can the authors of the full paper be revised?",
    answer:
      "Yes. Authors listed in the abstract may be revised during the full paper submission stage. Please note that the submitted full paper cannot be replaced. Any revisions may only be made after the review results are released.",
  },
  {
    question: "Will the presentation be conducted online or offline?",
    answer:
      "The presentation will be conducted on-site at the IPB International Convention Center (IICC), Bogor, Indonesia.",
  },
  {
    question:
      "What happens if the payment has been made but the paper is rejected? Is a refund available?",
    answer:
      "1. If the paper is rejected by IOP, no refund will be provided.\n2. If the paper is rejected during the review process, a refund will be made after certain deductions.",
  },
  {
    question:
      "Does the registration fee include the excursion on the third day?",
    answer:
      "No, the excursion is optional and requires a separate payment from the initial registration.",
  },
  {
    question: "When will the Letter of Acceptance (LoA) be issued?",
    answer:
      "The Letter of Acceptance (LoA) will be issued after the payment is confirmed. If you encounter any issues, please contact us via email.",
  },
  {
    question:
      "I am a participant under the 'Presenter Only' category. Where can I submit my full paper?",
    answer:
      "Participants under the 'Presenter Only' category are not required to submit a full paper.",
  },
  {
    question:
      "Are international participants allowed to make payments in Indonesian Rupiah (IDR)?",
    answer:
      "No. International participants are required to make payments in USD only.",
  },
  {
    question: "Can the payment be made using a credit card?",
    answer:
      "No. Currently, credit card payment is not supported by the University’s Financial Department (IPB Finance).",
  },
  {
    question: "Is it mandatory to submit presentation materials through Moressier?",
    answer: "No. Participants are not required to submit presentation materials.",
  },
  {
    question: "Will certificates be issued for participants?",
    answer: "Yes. Certificates will be issued for both presenters and participants.",
  },
  {
    question:
      "Where can I obtain information regarding the full paper submission link, guidelines, and template?",
    answer:
      "The full paper submission link, along with the guidelines and template, can be found on the APFITA 2025 website under the 'Submissions' page.",
  },
  {
    question: "Will the papers be published in a Scopus-indexed publisher?",
    answer:
      "Yes. Accepted papers will be published in the IOP Conference Series: Earth and Environmental Science (EES).",
  },
  {
    question: "When is the registration payment deadline?",
    answer:
      "October 15, 2025. If you have any difficulties, please contact us via email.",
  },
  {
    question: "Can new full papers still be submitted?",
    answer:
      "Participants cannot submit a new full paper without going through the abstract submission stage first.",
  },
]
